var _style, _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiplexlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 701.66 267.36",
    style: {
      enableBackground: "new 0 0 701.66 267.36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#F04923;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.31,32.54c6.6,0,11.98-5.38,11.98-11.98c0-6.6-5.38-11.98-11.98-11.98s-11.98,5.38-11.98,11.98 C199.33,27.16,204.71,32.54,211.31,32.54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.02,78.58l1.83,4.08c0,0,14.86-7.06,15.59,6.49c0.73,13.55,0.36,73.13,0.36,73.13c0,0,0.95,11.36-16.02,11 l0,3.93h52.52v-4.66c0,0-15.88,3.21-16.09-11.58c-0.22-14.79,0-96.3,0-96.3l-5.28,0L183.02,78.58z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.02,7.24v1.5v3.17c0,0,23.92-2.91,23.78,13.69c-0.14,16.61,0,133.45,0,133.45c0,0-0.88,16.31-23.9,13.55 l0,4.66h73.13v-4.51c0,0-23.31,3.78-24.04-13.99c-0.72-17.78-0.58-60.68-0.58-60.68s59.01,14.89,76.05-20.83 c17.08-35.79-12.24-65.3-37.59-68.51C307.52,5.53,246.01,7.24,246.02,7.24 M294.23,19.76c52.45-14.28,52.15,35.84,52.15,35.84 c-0.58,51.86-52.16,35.26-52.16,35.26L294.23,19.76z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.47,19.07l32.78-13.69l5.69,0.15v155.91c0,0-0.34,13.13,16.97,12.23v3.52h-53.22v-3.93 c0,0,14.71,2.33,15.73-11.14l0-133.12c0,0-1.36-12.56-15.85-5.71L381.47,19.07z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.36,104.54c-1.64,50.74,53.8,75.68,73.46,25.8l4.03,2.33c0,0-8.18,48.66-52.03,44.29 c-63.62-7.94-57.99-130.89,21.41-116.54c0,0,31.15,7.08,29.72,43.99L464.36,104.54z M464.94,97.69h51.51c0,0-0.23-29.43-22.95-30.3 C470.77,66.51,463.92,89.68,464.94,97.69z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.35,173.28c0-1.92-2.31-3.75-3.09-4.22l-0.14-0.08c-2.71-1.51-11.2,0.1-14.51-6.05 c-8.6-15.95-17.2-38.09-26.56-61.13c-13.25-32.62-28.96-66.59-40.72-91.42c-0.53-1.11-1-2.98-2.67-2.98 c-1.17,0-2.82,0.8-4.89,2.42c-2.25,1.75-18.92,15.29-17.92,16.54l4.43,5.56L32.95,140.64c-3.35,8.41-6.97,17.71-9.72,21.51 c-3.67,5.09-18.16,7.08-17.81,11.35l0.36,3.87l51.92-0.06l-1.01-6.33c-0.19-1.53-1.46-0.88-5.31-1.45 c-6.41-0.95-21.45-0.89-13.83-17.73l16.02-35.4l58.28-0.71l16.96,39.76c3.99,12.82-8.14,13.12-14.35,14.19 c-1.53,0.18-2.53,0.38-3.57,0.51c-1.72,0.11-2.37,0.35-2.52,1.09l-1.01,6.33l17.44-0.21h57.54L182.35,173.28z M56.31,107.12 L80.96,43.4l0.88,1.91l25.61,60.06L56.31,107.12z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606.41,94.06c-2.64-5.05-6.16-9.11-8.98-14.02c-1.27-2.21-3.24-5.81-1.51-8.88l8.33-3.49l0.02-4.28 l-52.81-0.01v4.41c12.04-0.07,17.68,7.22,24.26,16.93c5,7.37,11.8,17.62,16.81,24.58l14.66,21.19c0.75,1.62,2.69,4.14,3.76,5.67 c3.44,4.93,16.9,23.75,17.19,27.81c0.46,6.51-8.26,6.76-10.77,7.23l-0.01,4.08l52.72,0.12l0.1-4.29l-17.47-9.61 c-1.68-1.43-19.44-27.5-22.34-31.58c-2.22-3.12-8.95-13.24-10.86-15.62L606.41,94.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M697.52,8.88c0.12,0.29,0.13,0.62-1.45,3.18c-9.52,15.49-21.05,29.9-31.55,44.88 c-22.38,31.92-44.88,63.73-67.32,95.75c-5.49,7.84-11.3,15.8-16.85,23.88c-2.8,4.08-6.42,7.19-11.9,8.46 c-6.29,1.46-11.86-0.95-15.25-4.31c-3.33-3.3-5.83-8.56-5.11-15.17c0.66-6.09,3.42-10.05,6.87-13.5 c20.37-20.37,40.49-41.05,60.85-61.41c17.05-17.05,33.63-34.27,50.63-51.27c6.8-6.8,13.45-13.61,20.28-20.44 c2.98-2.98,5.88-5.99,8.86-9.02c0.39-0.4,1.11-1.14,1.49-1.2C697.35,8.64,697.45,8.79,697.52,8.88z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 636.7642,
    y1: 257.6925,
    x2: 629.3582,
    y2: 197.3754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5644,
    style: {
      stopColor: "#EBECED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7A9AC"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M670.41,202.99l-17.48,9.61c-1.68,1.43-19.43,27.5-22.34,31.58c-1.63,2.29-5.68,8.34-8.48,12.35 c-1,1.43-1.84,2.61-2.36,3.25h-23.51l11.18-16.16c0.53-1.17,1.67-2.78,2.67-4.17c0.41-0.56,0.78-1.07,1.09-1.51 c3.44-4.92,16.9-23.75,17.19-27.81c0.46-6.51-8.26-6.76-10.77-7.23l-0.02-4.08l52.73-0.12L670.41,202.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 577.8447,
    y1: 186.0992,
    x2: 591.8486,
    y2: 265.5193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F04923"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0452,
    style: {
      stopColor: "#F1562A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    style: {
      stopColor: "#F37446"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2539,
    style: {
      stopColor: "#F89E78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3909,
    style: {
      stopColor: "#FDD7C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3926,
    style: {
      stopColor: "#FDD8C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#FEE6DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4766,
    style: {
      stopColor: "#FEF1EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    style: {
      stopColor: "#FFF9F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6123,
    style: {
      stopColor: "#FFFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8323,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M624.39,259.78h-28.15l-1.52,2.2c-0.74-0.74-1.46-1.47-2.18-2.2c-12.44-12.6-24.85-25.23-37.36-37.74 c-3.45-3.45-6.21-7.41-6.87-13.5c-0.72-6.61,1.78-11.87,5.11-15.17c3.39-3.36,8.97-5.77,15.25-4.31c5.49,1.27,9.1,4.39,11.9,8.46 c5.55,8.08,11.36,16.04,16.85,23.88c4.22,6.02,8.45,12.04,12.67,18.05c4.01,5.7,8.01,11.39,12.02,17.08 C622.87,257.61,623.63,258.69,624.39,259.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.7059,
    y1: 259.7821,
    x2: 209.7059,
    y2: 195.1621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2268,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5294,
    style: {
      stopColor: "#EBECED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9505,
    style: {
      stopColor: "#A7A9AC"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M235.97,195.16v4.66c0,0-15.88-3.2-16.09,11.58c-0.1,6.81-0.11,27.76-0.09,48.38h-20.27 c0.13-21.93-0.04-49.69-0.04-49.69s0.95-11.36-16.03-11l0.01-3.93H235.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.1359,
    y1: 259.7821,
    x2: 281.1359,
    y2: 195.1221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7233,
    style: {
      stopColor: "#EBECED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9505,
    style: {
      stopColor: "#A7A9AC"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M244.58,195.12l-0.01,4.66c23.02-2.76,23.91,13.55,23.9,13.55c0,0-0.02,20.99-0.05,46.45h24.67 c0.01-14.13,0.12-35.05,0.58-46.16c0.73-17.77,24.04-13.99,24.04-13.99v-4.51H244.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.9709,
    y1: 259.7821,
    x2: 408.9709,
    y2: 195.1721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1724,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6984,
    style: {
      stopColor: "#EBECED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7A9AC"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M435.58,195.17v3.53c-17.3-0.9-16.96,12.23-16.96,12.23v48.85H398.1v-49.53 c-1.02-13.47-15.73-11.14-15.73-11.14v-3.94H435.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 492.8055,
    y1: 259.7821,
    x2: 492.8055,
    y2: 195.1344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3796,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6622,
    style: {
      stopColor: "#EBECED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7A9AC"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M488.5,195.41c-31.02,3.87-45.58,35.07-43.15,64.37h17.91c4.07-45.18,54.65-64.91,73.24-17.75l4.03-2.33 C540.53,239.7,532.35,191.04,488.5,195.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.5578,
    y1: 259.7821,
    x2: 92.5578,
    y2: 194.8021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6658,
    style: {
      stopColor: "#EBECED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7A9AC"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M123.49,195.01l-17.44-0.21l1.01,6.33c0.15,0.74,0.8,0.97,2.52,1.09c1.04,0.13,2.04,0.33,3.57,0.51 c6.2,1.07,18.33,1.36,14.35,14.19l-16.96,39.76l-58.28-0.72l-16.03-35.4c-7.62-16.83,7.42-16.77,13.83-17.72 c3.85-0.57,5.12,0.07,5.31-1.46l1.01-6.33l-51.92-0.06l-0.36,3.87c-0.35,4.28,14.14,6.26,17.81,11.36 c2.74,3.8,6.37,13.1,9.72,21.51l11.18,28.05h98.29c7.7-19.07,14.94-36.91,22.19-50.35c3.31-6.15,11.8-4.54,14.51-6.04l0.14-0.09 c0.78-0.46,3.09-2.29,3.09-4.21v-4.08H123.49z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiplexlogo);
export default __webpack_public_path__ + "static/media/AIPLEX LOGO.ffa347305f7caf0a94fd028c27a56b53.svg";
export { ForwardRef as ReactComponent };